module.exports = __webpack_public_path__ + "img/big4-14.fda4c8ec.jpg";